import React, { useEffect } from "react";
import ArrowIcon from "assets/icons/Arrow.svg";

import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
const CustomPagination = ({
  totalCount,
  setCurrentPage,
  resultsPerPage,
  currentPage,
  padding = true,
  onResultsPerPageChange,
}) => {
  const totalPages = Math.ceil(totalCount / resultsPerPage);

  // Auto-adjust current page if it exceeds total pages
  useEffect(() => {
    if (currentPage > totalPages && totalPages > 0) {
      setCurrentPage(totalPages);
    }
  }, [currentPage, totalPages, setCurrentPage]);

  const pagesToShow = () => {
    const pages = [];
    if (totalPages <= 5) {
      for (let i = 1; i <= totalPages; i++) pages.push(i);
    } else {
      if (currentPage <= 3) {
        pages.push(1, 2, 3, "-", totalPages);
      } else if (currentPage >= totalPages - 2) {
        pages.push(1, "-", totalPages - 2, totalPages - 1, totalPages);
      } else {
        pages.push(1, "-", currentPage, "-", totalPages);
      }
    }
    return pages;
  };

  const goToPage = (page) => {
    if (page === "-" || page < 1 || page > totalPages) return;
    setCurrentPage(page);
  };
  return (
    <div
      className={`flex items-center overflow-hidden gap-2 sm2:gap-0   flex-col justify-center md:flex-row md:justify-between  w-full ${
        padding ? "p-4 bg-[#F3F3F3] " : ""
      }`}
    >
      <div className="flex items-center text-sm  gap-2  ">
        <span className="text-[#242424] text-[16px] font-medium ">
          Results per page:
        </span>
        <select
          className="p-3 rounded-[12px] border border-[#ECECEC] text-[#242424] bg-white focus:outline-none cursor-pointer"
          value={resultsPerPage}
          onChange={(e) => {
            const newResultsPerPage = Number(e.target.value);
            if (onResultsPerPageChange) {
              onResultsPerPageChange(newResultsPerPage);
            }
            setCurrentPage(1);
          }}
        >
          <option value="4">4</option>
          <option value="10">10</option>
          <option value="20">20</option>
          <option value="30">30</option>
          <option value="40">40</option>
        </select>
      </div>

      <Pagination
        count={totalPages}
        page={currentPage}
        onChange={(_, value) => goToPage(value)}
        variant="outlined"
        shape="rounded"
        color="primary"
        sx={{
          "& .MuiPaginationItem-root": {
            border: "1px solid #ECECEC",
            borderRadius: "12px",
            margin: "0 2px",
            backgroundColor: "#fff",
            padding: "12px",
            "&:hover": {
              backgroundColor: "#f5f5f5",
            },
          },
          "& .Mui-selected": {
            backgroundColor: "#3CAB5C !important",
            color: "#fff !important",
            borderRadius: "12px",
            border: "1px solid #3CAB5C !important",
            "&:hover": {
              backgroundColor: "#3CAB5C !important",
            },
          },
          "& .MuiPagination-ul": {
            gap: "8px",
          },
        }}
      />
    </div>
  );
};
export default CustomPagination;
